
export const accessToken = 'pk.eyJ1Ijoiam91cm5leXdvcmtzIiwiYSI6ImNrOGVjM2YwZzBreXIzZ21sdGN3NDNhcDYifQ.qu6gJ6MWvFULqxI4TijEVg'

export const mapStyle = 'mapbox://styles/journeyworks/ck8ec6o7q291c1jmve33kislu'

export const mapConfig = {
  zoom: 12.04,
  center: [4.701801, 51.767419]
}

export const planMode = true

export const layers = {
  hexagons: {
    url: 'mapbox://journeyworks.c2ai3rhv',
    source: "klapwijk_resultaat_per_hexago-02gzou",
    active: true
  },
  hexagonCenterpoints: {
    url: "mapbox://",
    source: "",
    active: false
  },
  parking: {
    url: "mapbox://journeyworks.cgdtcw44",
    source: "klapwijk_parkeervlakken-8gl5zr",
    active: true
  },
  trees: {
    url: "",
    source: "",
    active: false
  },
  chargingpoints: {
    url: "mapbox://journeyworks.08gu01cu",
    source: "klapwijk_oplaadpalen-9ortof",
    active: true
  },
  plannedchargingpoints: {
    active: planMode
  },
  fuelstations: {
    url: "mapbox://",
    source: "",
    active: false
  },
  border: {
    url: "mapbox://journeyworks.5tlwzmiw",
    source: "klapwijk_buurtgrens-an6zij",
    active: true
  },
  visitorlocations: {
    url: "mapbox://journeyworks.1gvi8fqk",
    source: "klapwijk_bezoekers_hexid-0kpkjh",
    active: true
  },
  pplusr: {
    url: "mapbox://",
    source: "",
    active: false
  },
  ls: {
    url: "mapbox://journeyworks.7h61jhxu",
    source: "klapwijk_laagspanning-61ab14",
    active: true
  },
  ovkasten: {
    url: "mapbox://",
    source: "",
    active: false
  }
}

